import { ApiFunc, getInstance } from '@helpers/httpClient'

import * as API from '../constants/api'

export const videoTutorial: ApiFunc<`${typeof API.VIDEO_TUTORIAL}`, 'get'> = data =>
  getInstance().get(API.VIDEO_TUTORIAL, {
    params: data,
  })
